import { getAccountData } from '../apis/rpm.js';
import getStore from '../store/index.js';
import { actions as rmAccountActions } from '../store/state/rpmAccountData.js';

export async function preloadAccountData() {
  const store = getStore();

  const state = store.getState();

  if (state.rpmAccountData.loading || state.rpmAccountData.data != null) {
    return;
  }

  store.dispatch(rmAccountActions.START_LOADING());
  try {
    const accountData = await getAccountData();
    store.dispatch(rmAccountActions.ON_DATA(accountData));
  } catch {
    store.dispatch(rmAccountActions.FINISH_LOADING());
  }
}
